import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';
import { FileItem } from '@app_modules/loan-applications/step1/file-item';

interface Response extends BackendResponse {}

interface Payload {
  report_id: number|string;
  file_id: number|string;
}

export function useRemoveSource(report_id: number|string, file_id: number|string) {
  return useMutation({
    mutationFn: ({report_id, file_id}: Payload) =>
      removeFileItem({report_id: report_id, file_id: file_id}),
      onSuccess: (response: any, payload) => {
      if (response.message) {
        toast(
          message(response.message),
        );
      } else {
        toast(
          message(`You has just removed file item.`),
        );
      }
      
      // queryClient.invalidateQueries({queryKey: DatatableDataQueryKey(`market-rates/${id}`)});
    },
    onError: err => showHttpErrorToast(err),
  });
}

function removeFileItem({
  report_id, file_id
}: Payload): Promise<Response> {
  return apiClient
    .post(`${report_id}/demo-remove-source-uw`, {file_id: file_id})
    .then(r => r.data);
}

